import React from 'react';

import {
  Typography,
} from '@material-ui/core';

import { createMuiTheme } from '@material-ui/core/styles';
import * as constants from './config/constants';

import classes from './css/getCSS';

import ratibhai from './assets/img/ratibhai.jpg';
import khemka from './assets/img/khemka.jpg';
import lohanaMahaparishad from './assets/img/lohana_mahaparishad.png';
import { AUSTRALIA_SITE_HOST, NZFIJI_SITE_HOST, WWW_LMP_LAGNASETU_HOST } from "./config/constants";


export const themeColors = {
  [constants.WWW_LMP_LAGNASETU_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#a23e4f',
  },
  [constants.MUMBAI_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.CANADA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.GCC_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.TANZANIA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.USA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.CENTRALGUJARAT_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.SOUTHGUJARAT_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.SOUTHINDIA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.EASTINDIA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.SAURASHTRA4_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.SAURASHTRA2_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#012130',
  },
  [constants.MAHARASHTRA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#3a2d27',
  },
  [constants.KENYA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#3a2d27',
  },
  [constants.EUROPE_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#3a2d27',
  },
  [constants.KUTCH_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#d76010',
  },
  [constants.VIDARBHA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#d76010',
  },
  [constants.NORTHINDIA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#d76010',
  },
  [constants.SAURASHTRA3_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#d76010',
  },
  [constants.CENTRAL_INDIA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#d76010',
  },
  [constants.UGANDA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#d76010',
  },
  [constants.SAURASHTRA1_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#ca602c',
  },
  [constants.NORTHGUJARAT_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#ca602c',
  },
  [constants.AFRICA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#ca602c',
  },
  [constants.AUSTRALIA_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#ca602c',
  },
  [constants.NZFIJI_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#ca602c',
  },
  // [constants.MAIN_SITE_HOST]: {
  //   primaryMain: 'rgba(255,255,255,0.7)',
  //   primaryLight: '#ec7b8d',
  //   primaryDark: '#a23e4f',
  // },
  [constants.MAIN_SITE_HOST]: {
    // primaryMain: 'rgba(255,255,255,0.7)',
    primaryMain: '#2e2222',
    primaryLight: '#ec7b8d',
    primaryDark: '#a23e4f',
  },
  [constants.LOHANA_SITE_HOST]: {
    primaryMain: '#2196F3',
    primaryLight: '#4dabf5',
    primaryDark: '#1d87da',
  },
  [constants.DIVORCEE_SITE_HOST]: {
    primaryMain: '#e85a71',
    primaryLight: '#ec7b8d',
    primaryDark: '#a23e4f',
  },
  [constants.NRI_SITE_HOST]: {
    primaryMain: '#AB47BC',
    primaryLight: '#ad65ba',
    primaryDark: '#bb6bc9',
  },
  [constants.JAIN_SITE_HOST]: {
    primaryMain: '#2196F3',
    primaryLight: '#4dabf5',
    primaryDark: '#1d87da',
  },
  [constants.GORMAHARAJ_HOST]: {
    primaryMain: '#AB47BC',
    primaryLight: '#ad65ba',
    primaryDark: '#bb6bc9',
  },
  [constants.SHAADIYOG_HOST]: {
    primaryMain: '#2196F3',
    primaryLight: '#4dabf5',
    primaryDark: '#1d87da',
  },
};


export const getTheme = () => {
  let theme = null;

  theme = createMuiTheme({
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
      MuiInput: {
        disableUnderline: true,
      },
    },
    typography: {
      fontFamily: 'Source Sans Pro',
    },
    palette: {
      primary: {
        main: themeColors[window.location.host].primaryMain,
        light: themeColors[window.location.host].primaryLight,
        dark: themeColors[window.location.host].primaryDark,
        contrastText: '#fff',
      },
      info: {
        main: '#26C6DA',
        light: '#51d1e1',
        dark: '#1a8a98',
        contrastText: '#000',
      },
      success: {
        main: '#009688',
        light: '#33ab9f',
        dark: '#00695f',
        contrastText: '#fff',
      },
      warning: {
        main: '#ffc107',
        light: '#ffcd38',
        dark: '#b28704',
        contrastText: '#000',
      },
      danger: {
        main: '#F44336',
        light: '#f6685e',
        dark: '#aa2e25',
        contrastText: '#fff',
      },
      secondary: {
        main: '#607D8B',
        light: '#7f97a2',
        dark: '#435761',
        contrastText: '#fff',
      },
    },
  });

  return theme;
};


export const getHomeCover = () => {
  let cover = null;
  if (window.location.host === constants.WWW_LMP_LAGNASETU_HOST) {
    cover = require('./assets/backs/Rajkot-Bureau.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.MAIN_SITE_HOST) {
    cover = require('./assets/backs/Rajkot-Bureau.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.MUMBAI_SITE_HOST) {
    cover = require('./assets/backs/mumbai.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.CANADA_SITE_HOST) {
    cover = require('./assets/backs/Canada.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.EUROPE_SITE_HOST) {
    cover = require('./assets/backs/UK.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.GCC_SITE_HOST) {
    cover = require('./assets/backs/GCC.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.USA_SITE_HOST) {
    cover = require('./assets/backs/USA.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.AFRICA_SITE_HOST) {
    cover = require('./assets/backs/South-Africa.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.TANZANIA_SITE_HOST) {
    cover = require('./assets/backs/Tanzania.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.KENYA_SITE_HOST) {
    cover = require('./assets/backs/Kenya.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.UGANDA_SITE_HOST) {
    cover = require('./assets/backs/Uganda.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.AUSTRALIA_SITE_HOST) {
    cover = require('./assets/backs/Australia.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.NZFIJI_SITE_HOST) {
    cover = require('./assets/backs/New-Zealand.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.CENTRALGUJARAT_SITE_HOST) {
    cover = require('./assets/backs/Ahmedabad.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.SOUTHGUJARAT_SITE_HOST) {
    cover = require('./assets/backs/surat.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.SOUTHINDIA_SITE_HOST) {
    cover = require('./assets/backs/South-India.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.EASTINDIA_SITE_HOST) {
    cover = require('./assets/backs/East-India.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.SAURASHTRA4_SITE_HOST) {
    cover = require('./assets/backs/bhavnagar.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.SAURASHTRA2_SITE_HOST) {
    cover = require('./assets/backs/jamnagar.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.MAHARASHTRA_SITE_HOST) {
    cover = require('./assets/backs/New-Mumbai.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.KUTCH_HOST) {
    cover = require('./assets/backs/kutch.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.VIDARBHA_SITE_HOST) {
    cover = require('./assets/backs/vidharbh.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.NORTHINDIA_SITE_HOST) {
    cover = require('./assets/backs/North-India.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.SAURASHTRA3_SITE_HOST) {
    cover = require('./assets/backs/junagadh.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.CENTRAL_INDIA_SITE_HOST) {
    cover = require('./assets/backs/Central-India.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.SAURASHTRA1_SITE_HOST) {
    cover = require('./assets/backs/rajkot.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.NORTHGUJARAT_SITE_HOST) {
    cover = require('./assets/backs/Gandhinagar.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.LOHANA_SITE_HOST) {
    cover = require('./assets/backs/Lohana-Samaj-Bureau.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.DIVORCEE_SITE_HOST) {
    cover = require('./assets/backs/back10.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.NRI_SITE_HOST) {
    cover = require('./assets/backs/banner-NRI.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.JAIN_SITE_HOST) {
    cover = require('./assets/backs/banner-jain.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.GORMAHARAJ_HOST) {
    cover = require('./assets/backs/back10.jpg');  // eslint-disable-line
  }
  if (window.location.host === constants.SHAADIYOG_HOST) {
    cover = require('./assets/backs/back10.jpg');  // eslint-disable-line
  }
  return cover;
};


export const getLogo = () => {
  let logo = null;
  if (window.location.host === constants.WWW_LMP_LAGNASETU_HOST || window.location.host === constants.SAURASHTRA4_SITE_HOST
      || window.location.host === constants.TANZANIA_SITE_HOST || window.location.host === constants.KENYA_SITE_HOST
      || window.location.host === constants.UGANDA_SITE_HOST || window.location.host === constants.AUSTRALIA_SITE_HOST
      || window.location.host === constants.NZFIJI_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.MAIN_SITE_HOST || window.location.host === constants.EASTINDIA_SITE_HOST
      || window.location.host === constants.GCC_SITE_HOST || window.location.host === constants.EUROPE_SITE_HOST ||
      window.location.host === constants.USA_SITE_HOST || window.location.host === constants.AFRICA_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.MUMBAI_SITE_HOST || window.location.host === constants.SAURASHTRA2_SITE_HOST ||
      window.location.host === constants.SOUTHGUJARAT_SITE_HOST || window.location.host === constants.SOUTHINDIA_SITE_HOST ||
      window.location.host === constants.CANADA_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.NORTHINDIA_SITE_HOST || window.location.host === constants.CENTRALGUJARAT_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.KUTCH_HOST || window.location.host === constants.MAHARASHTRA_SITE_HOST || window.location.host === constants.VIDARBHA_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.SAURASHTRA3_SITE_HOST || window.location.host === constants.CENTRAL_INDIA_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.SAURASHTRA1_SITE_HOST || window.location.host === constants.NORTHGUJARAT_SITE_HOST || window.location.host === constants.SOUTHGUJARAT_SITE_HOST || window.location.host === constants.SOUTHINDIA_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.LOHANA_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.DIVORCEE_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.NRI_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.JAIN_SITE_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.GORMAHARAJ_HOST) {
    logo = require('./assets/img/logos/logo_eng.png');  // eslint-disable-line
  }
  if (window.location.host === constants.SHAADIYOG_HOST) {
    logo = require('./assets/img/logos/sy.png');  // eslint-disable-line
  }
  return logo;
};


export const getHomeCaption = () => {
  let caption = null;
  if (window.location.host === constants.WWW_LMP_LAGNASETU_HOST || window.location.host === constants.EASTINDIA_SITE_HOST
      || window.location.host === constants.TANZANIA_SITE_HOST || window.location.host === constants.KENYA_SITE_HOST
      || window.location.host === constants.UGANDA_SITE_HOST || window.location.host === constants.AUSTRALIA_SITE_HOST
      || window.location.host === constants.NZFIJI_SITE_HOST ) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Decode your perfect life
          <br />
          partner With Us.
        </Typography>
      </React.Fragment>
    );
  }
  if (window.location.host === constants.MAIN_SITE_HOST || window.location.host === constants.SAURASHTRA4_SITE_HOST
      || window.location.host === constants.CENTRAL_INDIA_SITE_HOST || window.location.host === constants.GCC_SITE_HOST
      || window.location.host === constants.EUROPE_SITE_HOST || window.location.host === constants.USA_SITE_HOST
      || window.location.host === constants.AFRICA_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Decode your perfect life
          <br />
          partner With Us.
        </Typography>
      </React.Fragment>
    );
  }
  if (window.location.host === constants.MUMBAI_SITE_HOST || window.location.host === constants.SAURASHTRA2_SITE_HOST
      || window.location.host === constants.SOUTHGUJARAT_SITE_HOST || window.location.host === constants.SOUTHINDIA_SITE_HOST
      || window.location.host === constants.CANADA_SITE_HOST) {
    caption = (
        <React.Fragment>
          <Typography variant="display3" className={classes.coverCaption}>
            Decode your perfect life
            <br />
            partner With Us.
          </Typography>
        </React.Fragment>
    );
  }
  if (window.location.host === constants.NORTHINDIA_SITE_HOST || window.location.host === constants.CENTRALGUJARAT_SITE_HOST) {
    caption = (
        <React.Fragment>
          <Typography variant="display3" className={classes.coverCaption}>
            Decode your perfect life
            <br />
            partner With Us.
          </Typography>
        </React.Fragment>
    );
  }
  if (window.location.host === constants.KUTCH_HOST || window.location.host === constants.SAURASHTRA3_SITE_HOST || window.location.host === constants.SAURASHTRA3_SITE_HOST || window.location.host === constants.VIDARBHA_SITE_HOST) {
    caption = (
        <React.Fragment>
          <Typography variant="display3" className={classes.coverCaption}>
            Decode your perfect life
            <br />
            partner With Us.
          </Typography>
        </React.Fragment>
    );
  }
  if (window.location.host === constants.SAURASHTRA1_SITE_HOST || window.location.host === constants.MAHARASHTRA_SITE_HOST || window.location.host === constants.NORTHGUJARAT_SITE_HOST || window.location.host === constants.SOUTHINDIA_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Decode your perfect life
          <br />
          partner With Us.
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.LOHANA_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Decode your perfect life
          <br />
          partner With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Lohanas
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.DIVORCEE_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Decode your perfect life
          <br />
          partner With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Divorcees
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.NRI_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Decode your perfect life
          <br />
          partner With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          NRIs
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.JAIN_SITE_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Decode your perfect life
          <br />
          partner With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Jains
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.GORMAHARAJ_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
          Decode your perfect life
          <br />
          partner With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Elite Matrimony
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  if (window.location.host === constants.SHAADIYOG_HOST) {
    caption = (
      <React.Fragment>
        <Typography variant="display3" className={classes.coverCaption}>
        Decode your perfect life
          <br />
          partner With Us.
        </Typography>
        <Typography className={classes.captionTag}>
          Inspired by our father Late Shri Bhawanishankarji Khemka
        </Typography>
        <br />
      </React.Fragment>
    );
  }

  return caption;
};


export const detectIE = () => {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
};


export const getKakaImage = () => {
  if (window.location.host === constants.SHAADIYOG_HOST) {
    return khemka;
  }
  return lohanaMahaparishad;
};


export const getKakaImageDynamic = (content = 'anjal') => {
  if (content === 'sy') {
    return khemka;
  }
  return ratibhai;
};


export const getKakaTagline = () => {
  if (window.location.host === constants.SHAADIYOG_HOST) {
    return '"He gave us the slogan \'Don\'t worry about the problem, find a solution and keep going\'. We all at Khemka family are excelling following principles and values he laid down on us. \n His blessings are always there with us..."';
  }
  // eslint-disable-next-line consistent-return
  return '"For the first time in the history of our "Matrusanstha Shree Lohana Mahaparishad" Matrimonial website has been created for the marriage aspirants of entire Lohana Community."';
};



// WEBPACK FOOTER //
// ./src/util.js